var map = {
	"./chart-one.png": 4052,
	"./embedding-graph-plan-1.svg": 3552,
	"./embedding-graph-plan-ar.svg": 204,
	"./embedding-graph-plan.svg": 9490,
	"./emissions.svg": 3307,
	"./matrix-one.jpg": 3281,
	"./plan-one-ar.svg": 6326,
	"./plan-one.png": 5275,
	"./stakeholder-1-ar.svg": 7378,
	"./stakeholder-1.svg": 3091,
	"./stakeholder-2-ar.svg": 5201,
	"./stakeholder-2.svg": 3974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7703;